import { validateScheduleArguments } from './scheduleArgumentsSchema.js';

const isActiveScheduleTrigger = (step) => step?.appSlug === 'schedule' && step?.isSkipped !== true;

// Publishing makes the draft the runtime source, and the scheduler selects runs from
// main.workflow_schedule rows built from these same arguments. A schedule trigger that
// fails the schedule schema (Fixed Times with no run time, an interval of 0) can never
// fire, so a publish that would ship it is refused and the offending step is named.
export const getSchedulePublishPolicy = (workflow) => {
  const scheduleSteps = (workflow?.steps || []).filter(isActiveScheduleTrigger);

  for (const step of scheduleSteps) {
    const validation = validateScheduleArguments(step?.arguments);
    if (!validation.ok) {
      return {
        success: false,
        message: `The Schedule trigger is incomplete (${validation.issues.map((issue) => issue.message).join('; ')}). Complete it before publishing.`,
        data: { stepId: step?.id, issues: validation.issues }
      };
    }
  }

  return { success: true, data: { stepIds: scheduleSteps.map((step) => step?.id) } };
};
